module.exports = __webpack_public_path__ + "img/time-closure-icon.d9ceae38.svg";